import { useNavigationHeader } from "@/src/common/navigationHeaderOptions";
import { WorkspaceFilesScreenComponent } from "../../OrgHome/WorkspaceFiles/WorkspaceFiles";
import { useIntlTokens } from "@/src/components/mobile/useIntlTokens";
import { LazyQueryNetworkBoundrary } from "@/src/components/mobile/QueryNetworkBoundrary";

import { AHIcon } from "arkh";
import { RoutineEditScreenProps } from "./RoutineEditNavigation";
import { useRoutineEditStateSetParamsFunction } from "../State/RoutineEditState";

export function WorkspaceRoutineEditFileSelect({
  navigation,
  route,
}: RoutineEditScreenProps<"WorkspaceRoutineEditFileSelect">) {
  const intl_token = useIntlTokens();
  useNavigationHeader({
    type: "CLOSE",
    title: intl_token.Files,
    onClose() {
      navigation.goBack();
    },
    defaultContentStyle: true,
  });

  const setParams = useRoutineEditStateSetParamsFunction();
  return (
    <LazyQueryNetworkBoundrary>
      {(fetchKey) => (
        <WorkspaceFilesScreenComponent
          onFileItemPress={(file) => {
            setParams((params) => ({
              ...params,
              addDescriptionFiles: [...params.addDescriptionFiles, file],
            }));
            navigation.goBack();
          }}
          itemActionComponent={<AHIcon type="add" color="primary" />}
          headerType="none"
          fetchKey={fetchKey}
          workspaceId={route.params.orgWorkspaceId}
          write
          onUploadedFiles={(fileIds) => {}}
        />
      )}
    </LazyQueryNetworkBoundrary>
  );
}
